module.exports = __webpack_public_path__ + "static/img/mysave-flash-logo.e89024fc.jpg";